import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { Button, Modal, Segment } from "semantic-ui-react";

import { hideConfirmModal } from "~/actions";

const UserUpdatedModal = ({ close }) => {
  const { t } = useTranslation();

  return (
    <Modal size="mini" open closeOnDimmerClick={false} onClose={close} basic>
      <Modal.Content>
        <Segment.Group style={{ border: "unset" }}>
          <Segment vertical textAlign="center" style={{ border: "unset" }}>
            {t("users.modal.permissions_updated_successfully")}
          </Segment>
        </Segment.Group>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={close} content="OK" />
      </Modal.Actions>
    </Modal>
  );
};

UserUpdatedModal.propTypes = {
  close: PropTypes.func
};

const mapDispatchToProps = dispatch => {
  return {
    close: () => dispatch(hideConfirmModal())
  };
};

export default connect(null, mapDispatchToProps)(UserUpdatedModal);
